module.exports = __webpack_public_path__ + "img/img_asset_valve_manometer.c94b5762.svg";